import React from "/vendor/react";
import cx from "/vendor/classnames";

import {
  makeStyles,
  createStyles,
  Theme,
  Typography,
} from "/vendor/@material-ui/core";

import useReqContext from "/lib/component/util/useReqContext";
import { InlineLink } from "/lib/component/base";
import { useRouter, NamespaceLink } from "/lib/component/util";
import ServiceNowIncidentAction from "../servicenowForm/ServiceNowIncidentAction";
import HardwareCatAction from "../hardwareCatalog/HardwareCatAction";
import WorkOrderAction from "../workorderForm/WorkOrderAction";
import {
  ClickAwayListener,
  Grow,
  MenuList,
  Paper,
  Popper,
  MenuItem,
} from "@material-ui/core";
import ServiceNowLogo from "../../static/ServiceNow-logo.svg";
import { useEffect, useRef, useState } from "react";
import ToteReportingAction from "/lib/component/toteReporting/ToteReportingAction";
import { getFormattedName } from "/lib/util/countries";


const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      },
      list: {
        width: "100%",
        textDecoration: "none",
      },
      listItem: {
        display: "inline",
        opacity: 0.71,
        marginRight: theme.spacing(1.5),
      },
      active: {
        opacity: 1,
      },
      separator: {
        opacity: 0.5,
      },
      paper: {
        marginRight: theme.spacing(2),
      },
    }),
  { name: "Breadcrumbs" },
);

const Separator = () => {
  const classes = useStyles();

  return <li className={cx(classes.listItem, classes.separator)}>›</li>;
};

interface CrumbProps {
  children: React.ReactElement | string;
  active?: boolean;
}

const Crumb = ({ children, active = false }: CrumbProps) => {
  const classes = useStyles();

  return (
    <li className={cx(classes.listItem, { [classes.active]: active })}>
      {children}
    </li>
  );
};

const Breadcrumbs = () => {
  const classes = useStyles();

  const { namespace, cluster } = useReqContext();

  const router = useRouter();
  const paths = router.location.pathname.split("/");
  const resource = paths[paths.indexOf(namespace) + 1] || "";
  const resourceNames = paths.slice(paths.indexOf(namespace) + 2);

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: any) => {
    // @ts-ignore
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: any) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current && !open) {
      // @ts-ignore
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Typography
      component="div"
      className={classes.root}
      noWrap
      color="textPrimary"
      variant="body2"
    >
      <ul className={classes.list}>
        {cluster && (
          <React.Fragment>
            <Crumb>
              <NamespaceLink
                component={InlineLink}
                cluster={cluster}
                namespace={namespace}
                to={"/"}
              >
                {cluster === "~" ? "local-cluster" : cluster}
              </NamespaceLink>
            </Crumb>

            <Separator />
          </React.Fragment>
        )}

        <Crumb>
          <NamespaceLink component={InlineLink} namespace={namespace} to={"/"}>
            {getFormattedName(namespace)}
          </NamespaceLink>
        </Crumb>

        <Separator />

        <Crumb active={resourceNames.length === 0}>
          {resourceNames.length > 0 ? (
            <NamespaceLink
              component={InlineLink}
              namespace={namespace}
              to={`/${resource}`}
            >
              {resource}
            </NamespaceLink>
          ) : (
            resource
          )}
        </Crumb>

        {resourceNames.map((name) => (
          <React.Fragment key={name}>
            <Separator />

            <Crumb active>{name}</Crumb>
          </React.Fragment>
        ))}
      </ul>
      {/* <button
        style={{
          right: 10,
          left: "auto",
          float: "right",
          marginRight: "10px",
          backgroundColor: "#00a3b5",
          color: "white",
          padding: "10px 20px",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <img src={ServiceNowLogo} alt={"SNow Logo"} height={"15px"} />
      </button> */}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{ zIndex: 9999 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem onClick={handleClose}>
                    <ServiceNowIncidentAction />
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <WorkOrderAction />
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      <HardwareCatAction />
      {/* <Button
        variant="contained"
        style={{ minWidth: "120px", marginLeft: "10px", padding: "10px"}}
        onClick={() => {}}
      >
        Daily Report
      </Button> */}
      {namespace === "tucson2023" ? <ToteReportingAction /> : null}
    </Typography>
  );
};

export default Breadcrumbs;
